import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { EIgrejaModule } from '../app/apps/eigreja/eigreja.module';
import { environment } from '../environments/environment';
import { recoverFromMissingZone } from './shared/ng0908-recovery';

// Aborta o bootstrap quando o zone.js não carregou (index.html/service worker
// stale servindo main sem polyfills): a recuperação recarrega a página com
// assets frescos. Sem isso o Angular lança NG0908 e o app fica em tela branca
// (GESTOR-CLIENT-PK).
if (recoverFromMissingZone()) {
  // Recuperação em andamento (reload iminente) — não tenta bootstrapar.
} else {

if (environment.production) {
  enableProdMode();
}

document.title = 'E-igreja';

window.addEventListener('dragover', event => event.preventDefault(), false);
window.addEventListener('drop', event => event.preventDefault(), false);

platformBrowserDynamic().bootstrapModule(EIgrejaModule);

}
